import React from 'react';
import PropTypes from 'prop-types';

const Footer = props => (
  <footer>
    <nav className="navbar-bottom">
      <ul className="footer-nav">
        <li>
          <a
            href="//www.octanner.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            {props.translations.copyright}
          </a>
        </li>
        <li>
          <a href={props.privacyPolicyLink} target="_blank" rel="noopener noreferrer">
            {props.translations.privacy}
          </a>
        </li>
        <li>
          <a
            href="//www.octanner.com/contact-us.html"
            rel="noopener noreferrer"
            target="_blank"
          >
            {props.translations['contact-us']}
          </a>
        </li>
        <li>
          <select
            id="language-select"
            defaultValue={props.locale ? props.locale : 'select'}
            onChange={props.updateLocale}
          >
            <option disabled="true" value="select">
              Change Language
            </option>
            <option value="en-US">English (US)</option>
            <option value="en-GB">English (CA/UK)</option>
            <option value="fr-FR">French (Français)</option>
            <option value="fr-CA">French (Français Canada)</option>
            <option value="es-MX">Spanish (Español Américas)</option>
            <option value="es-ES">Spanish (Español España)</option>
            <option value="pt-PT">Portuguese (Português)</option>
            <option value="pt-BR">Portuguese (Português brasileiro)</option>
            <option value="it-IT">Italian (Italiano)</option>
            <option value="de-DE">German (Deutsch)</option>
            <option value="nl-NL">Dutch (Nederlands)</option>
            <option value="zh-CN">Chinese (Simplified 中文)</option>
            <option value="zh-HK">Chinese (Traditional 漢語)</option>
            <option value="ar-SA">Arabic (عربى)</option>
            <option value="ja-JP">Japanese (日本語)</option>
            <option value="ko-KR">Korean</option>
            <option value="th-TH">Thai (ไทย)</option>
            <option value="vi-VN">Vietnamese (Tiếng Việt)</option>
            <option value="pl-PL">Polish (polski)</option>
            <option value="in-ID">Indonesian (Indonesia)</option>
            <option value="mk-MK">Macedonian (македонски)</option>
            <option value="tr-TR">Turkish (Türkçe)</option>
          </select>
        </li>
      </ul>
    </nav>
  </footer>
);

Footer.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  updateLocale: PropTypes.func.isRequired,
  privacyPolicyLink: PropTypes.string.isRequired,
  locale: PropTypes.string,
};

Footer.defaultProps = {
  locale: '',
};

export default Footer;
